import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }

import { PropType, ref, toRefs, watch } from "vue";
import { RouteLocationRaw } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  btnStyle: {
    type: String as PropType<
      "primary" | "outline-primary" | "white" | "outline-white" | "transparent"
    >,
    required: false,
    default: "primary",
  },
  size: {
    type: String as PropType<"xs" | "sm" | "lg">,
    required: false,
    default: undefined,
  },
  href: {
    type: String,
    required: false,
    default: undefined,
  },
  to: {
    type: [String, Object] as PropType<RouteLocationRaw>,
    required: false,
    default: undefined,
  },
  icon: {
    type: String,
    required: false,
    default: undefined,
  },
  circle: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props



const tag = ref("");
const attributeName = ref("");
const attributeValue = ref<string | RouteLocationRaw>();
const cssClasses = ref<string[]>([]);

function configureButton() {
  if (props.href !== undefined) {
    tag.value = "a";
    attributeName.value = "href";
    attributeValue.value = props.href;
  } else if (props.to !== undefined) {
    tag.value = "RouterLink";
    attributeName.value = "to";
    attributeValue.value = props.to;
  } else {
    tag.value = "button";
    attributeName.value = "";
    attributeValue.value = undefined;
  }

  cssClasses.value = [`btn-${props.btnStyle}`];

  if (props.btnStyle !== "transparent") {
    cssClasses.value.push("btn");
  }

  if (props.size) {
    cssClasses.value.push(`btn-${props.size}`);
  }

  if (props.icon) {
    cssClasses.value.push("btn-with-icon");
  }

  if (props.circle) {
    cssClasses.value.push("btn-circle");
  }
}

configureButton();
watch(() => toRefs(props), configureButton);

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(tag.value), _normalizeProps({
    [attributeName.value || ""]: attributeValue.value,
    class: cssClasses.value
  }), {
    default: _withCtx(() => [
      (__props.icon !== undefined)
        ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
            key: 0,
            icon: `fa-solid fa-${__props.icon}`
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})